import { createRouter, createWebHistory, Router } from 'vue-router'
import {guardAuth } from './guards';
import { authenticatedRoutes } from './authenticated.routes'
import { unauthenticatedRoutes } from './unauthenticated.routes'
import KeycloakService from '@/services/keycloak/keycloakService';

const router: Router = createRouter({
  history: createWebHistory(),
  routes: [
    ...unauthenticatedRoutes,
    ...authenticatedRoutes
  ],
  scrollBehavior() {
    return { top: 0, left: 0 }
  }
});

router.beforeEach((to, from, next) => {
 guardAuth(to, from, next);
 if(KeycloakService.IsAuthenticated()){
  KeycloakService.RefreshToken();
 }
})

export default router
